import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiAvatar } from '@taiga-ui/kit';
import { TuiLoader, TuiScrollbar, TuiScrollable, TuiButton, TuiHint } from '@taiga-ui/core';
import { SharedModule } from '@src/app/shared';
import { ListModule } from '@src/app/shared/list';
import { IconModule } from '@src/app/modules/icon';
import { SearchUsersModule } from '@src/app/modules/search-users';

import { UsersListComponent } from './users-list.component';

@NgModule({
  declarations: [UsersListComponent],
  imports: [
    CommonModule,
    SearchUsersModule,
    SharedModule,
    TuiAvatar,
    TuiButton,
    TuiLoader,
    TuiScrollbar,
    TuiScrollable,
    ...TuiHint,
    ListModule,
    IconModule,
  ],
  exports: [UsersListComponent],
})
export class UsersListModule {}
